export const formatCardNumber = (cardNumber: string | null): string => {
  if (cardNumber === null) {
    return ''
  }

  const cleaned = cardNumber.replace(/\D/g, '')
  const match = cleaned.match(/(\d{1,4})/g)
  return match ? match.join(' ') : cardNumber
}
